import React from 'react';

import MapIcon from 'assets/LeadInfo/map.svg';
import PersonIcon from 'assets/LeadInfo/person.svg';
import PhoneIcon from 'assets/LeadInfo/phone.svg';
import EmailIcon from 'assets/LeadInfo/sms.svg';

import {
  ContactContent,
  ContactFildes,
  ContactInputBox,
  ContactTitle,
  InputContent,
  InputIcon,
  InputLabel,
  TitleIcon,
} from './ContactInfo.styles';

const ContactInfo = ({ leadData }) => {
  const addressParts = [
    leadData?.street?.name,
    leadData?.buildingHouse?.name,
    leadData?.apt,
    leadData?.city?.name,
    leadData?.administrativeRegion?.name,
    leadData?.district?.name,
    leadData?.country?.name,
  ].filter(Boolean);

  const address = addressParts?.length > 0 ? addressParts.join(', ') : 'N/A';

  return (
    <ContactContent>
      <ContactTitle>
        <TitleIcon src={PersonIcon} />
        Contact Information
      </ContactTitle>

      {(leadData?.phoneNumber || leadData?.email) && (
        <ContactFildes>
          {leadData?.phoneNumber && (
            <ContactInputBox>
              <InputLabel>
                <InputIcon src={PhoneIcon} />
                Phone
              </InputLabel>
              <InputContent>{leadData.phoneNumber}</InputContent>
            </ContactInputBox>
          )}
          {leadData?.email && (
            <ContactInputBox>
              <InputLabel>
                <InputIcon src={EmailIcon} />
                Email
              </InputLabel>
              <InputContent>{leadData.email}</InputContent>
            </ContactInputBox>
          )}
        </ContactFildes>
      )}
      {addressParts?.length > 0 && (
        <ContactFildes>
          <ContactInputBox>
            <InputLabel>
              <InputIcon src={MapIcon} />
              Address
            </InputLabel>
            <InputContent>{address}</InputContent>
          </ContactInputBox>
        </ContactFildes>
      )}
    </ContactContent>
  );
};

export default ContactInfo;
